import { render, staticRenderFns } from "./TipModal.vue?vue&type=template&id=586863fb&"
import script from "./TipModal.vue?vue&type=script&lang=js&"
export * from "./TipModal.vue?vue&type=script&lang=js&"
import style0 from "./TipModal.vue?vue&type=style&index=0&id=586863fb&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586863fb')) {
      api.createRecord('586863fb', component.options)
    } else {
      api.reload('586863fb', component.options)
    }
    module.hot.accept("./TipModal.vue?vue&type=template&id=586863fb&", function () {
      api.rerender('586863fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/TipModal.vue"
export default component.exports